import script from "./WaitingAlertBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./WaitingAlertBanner.vue?vue&type=script&setup=true&lang=ts"

import "./WaitingAlertBanner.vue?vue&type=style&index=0&id=09fe399a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09fe399a"]])

export default __exports__